import { BE1_API } from '../config/api';
// "데이터 정의" 관련 보조 API 유틸.
// 영속 상태(store/dataDefinitionsSlice.ts)와 달리, 서버 파일시스템 브라우징은 그때그때 조회하는
// 임시 UI 상태라서 redux에 두지 않고 여기서 plain fetch 로 제공한다.


export interface FsEntry {
  name: string;
  path: string;
  type: 'dir' | 'file';
  size: number | null;
}

export interface FsBrowseResult {
  path: string;
  parent: string | null;
  entries: FsEntry[];
}

export async function browseServerFs(path: string = ''): Promise<FsBrowseResult> {
  const res = await fetch(`${BE1_API}/api/fs/browse?path=${encodeURIComponent(path)}`);
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}
